import dwhExport from '~/dwhExport'
import { Dialog, Message, Processing, ErrorLoad } from '@wg/wows-react-uikit'
import { isoToFormattedLocalDate, isoToFormattedLocalTime } from 'helpers/datetime'
import { t, x } from 'helpers/localization'
import filter from 'lodash/filter'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import { Interpolate } from 'react-i18next'
import { AccountRecommendationsSettings, ClanRecommendation, PURPOSES, PURPOSE_TITLES, RecommendationsPurpose } from '../../Actions/ActionRecommendations'
import ApplicationDialog from './ApplicationDialog/ApplicationDialog'
import CategoryCard from './CategoryCard/CategoryCard'
import ClanCardSlider from './ClanCardSlider/ClanCardSlider'
import { RECOMMENDATIONS_ROOT_PATH } from './constants'
import { getLanguagesMap } from './helpers'
import LanguagesDialog from './LanguagesDialog/LanguagesDialog'
import styles from './ViewRecommendations.scss'
import { isLoggedIn } from "~/utils/auth"

export type ViewRecommendations_Props = {
    isFetching: Boolean,

    isFetchingAccountSettings: Boolean,
    isFetchingClanSettings: Boolean,

    page: RecommendationsPurpose | 'categories',
    currentSlide: number,

    accountSettings: AccountRecommendationsSettings,
    recommendations: Array<ClanRecommendation>,
    leftApplicationCount: number,

    root: String,

    currentAccount: any,

    updateAccountSettings: (accountSettings: AccountRecommendationsSettings) => void,
    getRecommendations: (purpose: RecommendationsPurpose) => void,
    getLeftApplicationCount: () => void,
    sendApplication: (clan: ClanRecommendation, info: String) => void,
}

class ViewRecommendations extends PureComponent<ViewRecommendations_Props, any> {

    constructor(props) {
        super(props)

        this.state = {
            selectedClanId: 0,
            isSettingsDialogOpen: false,
            isApplicationDialogOpen: false,
        }

        this.navigate = this.navigate.bind(this)
        this.returnToCategories = this.returnToCategories.bind(this)
        this.loadRecommendations = this.loadRecommendations.bind(this)

        this.showSettingsDialog = this.showSettingsDialog.bind(this)
        this.hideSettingsDialog = this.hideSettingsDialog.bind(this)

        this.showApplicationDialog = this.showApplicationDialog.bind(this)
        this.hideApplicationDialog = this.hideApplicationDialog.bind(this)

        this.onFocusCategoryCardChanged = this.onFocusCategoryCardChanged.bind(this)

        this.updateAccountLanguages = this.updateAccountLanguages.bind(this)
        this.updateAccountUseVoiceChat = this.updateAccountUseVoiceChat.bind(this)

        this.sendApplication = this.sendApplication.bind(this)

        this.categories = {
            noObligations: React.createRef(),
            squadBattles: React.createRef(),
            clanBattles: React.createRef(),
        }

        this.loadRecommendations(props)
    }

    componentDidMount() {
        if (this.props.page !== 'categories') {
            dwhExport.send(`clanrec.${this.props.page}.open_page`)
        } else {
            dwhExport.send('clanrec.open_page')
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: ViewRecommendations_Props, nextContext) {
        const isPageNew = this.props.page !== nextProps.page
        if (isPageNew) {
            this.loadRecommendations(nextProps)
        }
    }

    loadRecommendations(props: ViewRecommendations_Props) {
        const isNotCategoriesPage = props.page !== 'categories'
        if (isNotCategoriesPage) {
            this.props.getRecommendations(props.page)
            this.props.getLeftApplicationCount()
        }
    }

    showSettingsDialog() {
        this.setState({
            ...this.state,
            isSettingsDialogOpen: true,
        })
    }

    hideSettingsDialog() {
        this.setState({
            ...this.state,
            isSettingsDialogOpen: false,
        })
    }

    showApplicationDialog(clanId) {
        this.setState({
            ...this.state,
            selectedClanId: clanId,
            isApplicationDialogOpen: true,
        })
    }

    hideApplicationDialog() {
        this.setState({
            ...this.state,
            isApplicationDialogOpen: false,
        })
    }

    onFocusCategoryCardChanged(uuid) {
        Object.values(this.categories).map((categoryCardRef) => {
            const categoryCard = categoryCardRef.current
            if (categoryCard.uuid !== uuid)
                categoryCard.blur()
        })
    }

    renderCategories(selectedLanguages) {
        let header = (
            <div key="clan_header" className={styles.header}>
                <span className={styles.pageTitle}>{t('Вступайте в клан')}</span>
                <span className={styles.pageSubTitle}>{t('Вступайте в кланы, сражайтесь за ресурсы и получайте уникальные награды, а также клановые бонусы!')}</span>
            </div>
        )
        if (this.props.currentAccount.clanId)
            header = (
                <div className={styles.header}>
                    <span className={styles.pageTitle}>{t('Другие кланы')}</span>
                    <span className={styles.pageSubTitle}>{t('Если ваши игровые предпочтения изменились или вы просто хотите сменить клан, воспользуйтесь рекомендательной системой и подберите себе новый клан.')}</span>
                </div>
            )

        return isLoggedIn() ? [
            header,
            <span key="categories_0" className={styles.sectionTitle}>{t('Мои предпочтения')}</span>,
            <div key="categories_1" className={styles.cards}>
                <CategoryCard
                    ref={this.categories.noObligations}
                    cssLevel={1}
                    onFocus={this.onFocusCategoryCardChanged}
                    banner="no_obligations"
                    title={PURPOSE_TITLES[PURPOSES.NO_OBLIGATIONS]}
                    text={t('Вступайте в клан и получайте экономические бонусы.')}
                    isFetching={this.props.isFetchingAccountSettings}
                    isSettingsEnabled={false}
                    onButtonClick={() => this.navigate(PURPOSES.NO_OBLIGATIONS)} />
                <CategoryCard
                    ref={this.categories.squadBattles}
                    cssLevel={2}
                    onFocus={this.onFocusCategoryCardChanged}
                    banner="squad_battles"
                    title={PURPOSE_TITLES[PURPOSES.SQUAD_BATTLES]}
                    text={t('Сражайтесь вместе с боевыми товарищами, которые готовы в любой момент поддержать огнём и советом.')}
                    isFetching={this.props.isFetchingAccountSettings}
                    useVoiceChat={this.props.accountSettings.useVoiceChat}
                    updateUseVoiceChat={this.updateAccountUseVoiceChat}
                    languages={selectedLanguages}
                    modifyLanguageSettings={this.showSettingsDialog}
                    onButtonClick={() => this.navigate(PURPOSES.SQUAD_BATTLES)} />
                <CategoryCard
                    ref={this.categories.clanBattles}
                    cssLevel={3}
                    onFocus={this.onFocusCategoryCardChanged}
                    banner="clan_battles"
                    title={PURPOSE_TITLES[PURPOSES.CLAN_BATTLES]}
                    text={t('Побеждайте в клановых событиях и получайте награды — от ценных ресурсов до уникальных кораблей.')}
                    isFetching={this.props.isFetchingAccountSettings}
                    useVoiceChat={this.props.accountSettings.useVoiceChat}
                    updateUseVoiceChat={this.updateAccountUseVoiceChat}
                    languages={selectedLanguages}
                    modifyLanguageSettings={this.showSettingsDialog}
                    onButtonClick={() => this.navigate(PURPOSES.CLAN_BATTLES)} />
            </div>,
        ] : [ header, <ErrorLoad message = {t('Чтобы просматривать рекомендации, войдите на сайт')} buttonTitle = {t('Войти')} onReloadClick = {() => {window.location.assign(window.cm_settings.authURL)}}/>]
    }

    navigate(page: string) {
        if (page !== 'categories') {
            dwhExport.send(`clanrec.${page}.open_page`)
        }
        let url = `${this.props.root}${RECOMMENDATIONS_ROOT_PATH}`
        if (page !== 'categories')
            url = `${this.props.root}${RECOMMENDATIONS_ROOT_PATH}/${page}/1`
        this.context.router.push(url)
    }

    returnToCategories() {
        this.navigate('categories')
    }

    sendApplication(info: String) {
        dwhExport.send(`clanrec.${this.props.page}.send_request`)
        const selectedClan = filter(this.props.recommendations, (x) => x.id === this.state.selectedClanId)[0]
        this.props.sendApplication(selectedClan, info)
    }

    updateAccountLanguages(languages: Array<String>) {
        this.props.updateAccountSettings({ ...this.props.accountSettings, languages })
    }

    updateAccountUseVoiceChat(useVoiceChat: Boolean) {
        this.props.updateAccountSettings({ ...this.props.accountSettings, useVoiceChat })
    }

    renderLanguageSettings(languagesMap) {
        return (
            <Dialog
                content={
                    <LanguagesDialog
                        languagesMap={languagesMap}
                        hideDialog={this.hideSettingsDialog}
                        updateLanguages={this.updateAccountLanguages} />
                }
                size={'worship'}
                isOverlay={false}
                isVisible={this.state.isSettingsDialogOpen}
                hideDialog={this.hideSettingsDialog}
                t={t} />
        )
    }

    renderApplicationForm() {
        return (
            <Dialog
                content={
                    <ApplicationDialog
                        leftApplicationCount={this.props.leftApplicationCount}
                        hideDialog={this.hideApplicationDialog}
                        sendApplication={this.sendApplication} />
                }
                size={'worship'}
                isOverlay={false}
                isVisible={this.state.isApplicationDialogOpen}
                hideDialog={this.hideApplicationDialog}
                t={t} />
        )
    }

    getAccountError() {
        const currentAccount = this.props.currentAccount

        const accountErrorsTypes = {
            noFreeApplications: this.props.leftApplicationCount === 0,
            inClanCooldown: currentAccount.inClanCooldownTill,
            isClanMember: currentAccount.clanId,
        }

        const accountErrorsMessages = {
            noFreeApplications: t('На сегодня у вас не осталось заявок в кланы'),
            inClanCooldown: (
                <Interpolate
                    useDangerouslySetInnerHTML={true}
                    i18nKey={x('Вы недавно покинули клан. Вы сможете подать заявку в клан начиная с %(date)s&nbsp;%(time)s.')}
                    date={isoToFormattedLocalDate(currentAccount.inClanCooldownTill)}
                    time={isoToFormattedLocalTime(currentAccount.inClanCooldownTill)}
                    parent={'p'}
                    t={t}
                />
            ),
            isClanMember: t('Вы уже состоите в клане'),
        }

        for (let errorKey in accountErrorsTypes) {
            if (accountErrorsTypes[errorKey]) return accountErrorsMessages[errorKey]
        }

        return null
    }

    renderClanRecommendations() {
        const hasRecommendations = this.props.recommendations.length !== 0
        const messageText = this.props.leftApplicationCount === 0 ? t('На сегодня у вас не осталось заявок в кланы') : t('Оставшееся количество заявок в кланы на сегодня: %(count)s', { count: this.props.leftApplicationCount })
        const messageElement = (
            <div className={styles.applicationsLeftMessage}>
                <Message type="none" style="inline">{messageText}</Message>
            </div>
        )
        const accountError = this.getAccountError()

        return (
            <div className={styles.subWrapper}>
                <div className={styles.header}>
                    <span className={styles.pageTitle}>{t('Рекомендованные кланы')}</span>
                    <span className={styles.pageSubTitle}>{t('Список наиболее подходящих кланов формируется в зависимости от вашей активности и выбранных предпочтений.')}</span>
                </div>
                <span className={styles.sectionTitle}>{PURPOSE_TITLES[this.props.page]}</span>
                <span className={styles.backMessage}>
                    <a onClick={this.returnToCategories}>
                        {hasRecommendations ? t('Изменить условия подбора') : null}
                    </a>
                </span>
                <div className={styles.cards}>
                    <ClanCardSlider
                        returnToCategories={this.returnToCategories}
                        purpose={this.props.page}
                        currentSlide={this.props.currentSlide}
                        onClanSelect={this.showApplicationDialog}
                        isClanSelectingEnabled={accountError === null}
                        errorMessage={accountError}
                        clans={this.props.recommendations}
                        root={this.props.root} />
                </div>
                {this.props.recommendations.length > 0 ? messageElement : null}
            </div>
        )
    }

    render() {
        const languagesMap = getLanguagesMap(this.props.accountSettings.languages)

        const languageSettings = this.renderLanguageSettings(languagesMap)
        const applicationForm = this.renderApplicationForm()

        const content = this.props.page === 'categories' ? this.renderCategories(this.props.accountSettings.languages) : this.renderClanRecommendations()

        return (
            <div className={styles.wrapper}>
                {languageSettings}
                {applicationForm}

                <div style={{ display: this.props.isFetching ? 'none' : 'block' }}>
                    <div className={styles.headImage} />

                    {content}
                </div>
                <Processing isFetching={this.props.isFetching} label="" />
            </div>
        )
    }
}

ViewRecommendations.contextTypes = {
    router: PropTypes.object.isRequired,
}

ViewRecommendations.defaultProps = {
    isFetching: false,

    isFetchingAccountSettings: false,
    isFetchingClanSettings: false,

    page: 'categories',
    currentSlide: 1,

    accountSettings: {
        languages: [],
        isVoiceRequired: false,
    },
    recommendations: [],
    leftApplicationCount: 0,

    root: '',

    updateAccountSettings: (accountSettings: AccountRecommendationsSettings) => { },
    getRecommendations: (purpose: RecommendationsPurpose) => { },
    getLeftApplicationCount: () => { },
    sendApplication: (clan: ClanRecommendation, info: String) => { },
}

export default ViewRecommendations
